import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const TaboolaOverviewGate = React.lazy(
  () => import("./TaboolaOverview.gate")
);

const TaboolaOverviewLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <TaboolaOverviewGate />
  </React.Suspense>
);
export default () => <TaboolaOverviewLoadable />;
